import { Navigate } from "react-router-dom";
import Tables from "layouts/user/index";
import Titles from "layouts/titles";
import PushNotifications from "layouts/pushNotificationa/index.js";
import ShowTile from "layouts/titles/showTile/index";
import ShowThreeD from "layouts/titles/ShowThreeD.js";
import ShowQuestions from "layouts/quizTitles/ShowQuestions.js";
import QuizTitles from "layouts/quizTitles";
import Universities from "layouts/universities";
import AdminStatsPage from "prof/AdminStatsPage";
import QuizSystem from "prof/QuizSystem";
import HeatMap from "prof/HeatMap";
import QuizResults from "prof/QuizResults";
import QuizInsights from "prof/QuizInsights";
import PresentationTitles from "prof/presentationTitles";
import PublicImagesPage from "layouts/publicImages";
import PresentationMakerPage from "prof/presentationTitles/PresentationMakerPage";
import SubscriptionDashboard from "../assets/theme/components/subscriptionDashboard.js";
import EarnersPage from "layouts/earners";
import CommunityAdsPage from "layouts/communityAds";
import Uploads from "layouts/uploads";
import CopilotUsagePage from "layouts/copilotUsage";
import CopilotUsageDetail from "layouts/copilotUsage/CopilotUsageDetail";
import StudyPlanUsageDetail from "layouts/copilotUsage/StudyPlanUsageDetail";
import MicrolabCopilotHub from "layouts/microlabCopilot";
import MicrolabCopilotProcessing from "layouts/microlabCopilot/ProcessingScreen";
import MicrolabCopilotStudyPack from "layouts/microlabCopilot/StudyPackScreen";
import PackagesPage from "layouts/packages";
import DiscountUsersPage from "layouts/packages/discount";
import DemoRequestsPage from "layouts/demoRequests";
import UnsubscribeReportPage from "layouts/unsubscribeReport";
import AppFeedbackPage from "layouts/appFeedback";
import CommunityPage from "layouts/community";
import VerifiedActivityPage from "layouts/verifiedActivity";
import ActivityAnalyticsPage from "layouts/activityAnalytics";
import MembersPage from "layouts/members";
import ExamSimulatorAdminPage from "layouts/examSimulator";
import UsmlePrepAdminPage from "layouts/usmlePrep";
import AnatomyExplorerSettingsPage from "layouts/anatomyExplorerSettings";
import ForceUpdateSettingsPage from "layouts/forceUpdateSettings";

import Icon from "@mui/material/Icon";

const adminRoutes = [
  {
    route: "/dashboard",
    key: "dashboardRedirect",
    component: <Navigate to="/stats" replace />,
  },
  {
    type: "collapse",
    name: "Stats",
    key: "stats",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/stats",
    component: <AdminStatsPage />,
  },
  {
    type: "collapse",
    name: "App Analytics",
    key: "app-analytics",
    icon: <Icon fontSize="small">monitoring</Icon>,
    route: "/app-analytics",
    component: <ActivityAnalyticsPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Microlab Copilot",
    key: "microlab-copilot",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/microlab-copilot",
    component: <MicrolabCopilotHub />,
  },
  {
    type: "collapse",
    name: "Exam Simulator",
    key: "exam-simulator",
    icon: <Icon fontSize="small">record_voice_over</Icon>,
    route: "/exam-simulator",
    component: <ExamSimulatorAdminPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "USMLE Prep",
    key: "usmle-prep",
    icon: <Icon fontSize="small">medical_services</Icon>,
    route: "/usmle-prep",
    component: <UsmlePrepAdminPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Copilot Usage",
    key: "copilot-usage",
    icon: <Icon fontSize="small">smart_toy</Icon>,
    route: "/copilot-usage",
    component: <CopilotUsagePage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Quiz Insights",
    key: "quiz-insights",
    hideInSidenav: true,
    icon: <Icon fontSize="small">psychology</Icon>,
    route: "/quiz/insights",
    component: <QuizInsights />,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Members",
    key: "members",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/members",
    component: <MembersPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Universities",
    key: "universities",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/universities",
    component: <Universities />,
  },
  {
    type: "collapse",
    name: "Demo requests",
    key: "demo-requests",
    icon: <Icon fontSize="small">event_available</Icon>,
    route: "/demo-requests",
    component: <DemoRequestsPage />,
  },
  {
    type: "collapse",
    name: "Unsubscribe feedback",
    key: "unsubscribe-report",
    icon: <Icon fontSize="small">unsubscribe</Icon>,
    route: "/unsubscribe-report",
    component: <UnsubscribeReportPage />,
  },
  {
    type: "collapse",
    name: "App feedback",
    key: "app-feedback",
    icon: <Icon fontSize="small">reviews</Icon>,
    route: "/app-feedback",
    component: <AppFeedbackPage />,
  },
  {
    type: "collapse",
    name: "Force update",
    key: "force-update",
    icon: <Icon fontSize="small">system_update</Icon>,
    route: "/force-update",
    component: <ForceUpdateSettingsPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Subscriptions",
    key: "subcriptionDashboard",
    icon: <Icon fontSize="small">subscriptions</Icon>,
    route: "/subcriptionDashboard",
    component: <SubscriptionDashboard />,
  },
  {
    type: "collapse",
    name: "Packages",
    key: "packages",
    icon: <Icon fontSize="small">local_offer</Icon>,
    allowedRoles: ["admin"],
    collapse: [
      {
        type: "collapse",
        name: "All packages",
        key: "packages-all",
        route: "/packages",
        component: <PackagesPage />,
        allowedRoles: ["admin"],
      },
      {
        type: "collapse",
        name: "Discount",
        key: "packages-discount",
        route: "/packages/discount",
        component: <DiscountUsersPage />,
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    type: "collapse",
    name: "Earning users",
    key: "earning-users",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/earning-users",
    component: <EarnersPage />,
  },
  {
    type: "collapse",
    name: "Community",
    key: "community",
    icon: <Icon fontSize="small">forum</Icon>,
    route: "/community",
    component: <CommunityPage />,
  },
  {
    type: "collapse",
    name: "Verified Activity",
    key: "verified-activity",
    icon: <Icon fontSize="small">verified_user</Icon>,
    route: "/verified-activity",
    component: <VerifiedActivityPage />,
  },

  {
    type: "collapse",
    name: "Community ads",
    key: "community-ads",
    icon: <Icon fontSize="small">ondemand_video</Icon>,
    route: "/community-ads",
    component: <CommunityAdsPage />,
  },
  // {
  //   type: "collapse",
  //   name: "Uploads",
  //   key: "uploads",
  //   icon: <Icon fontSize="small">cloud_upload</Icon>,
  //   route: "/uploads",
  //   component: <Uploads />,
  // },
  {
    name: "threeDTitles",
    key: "threeDTitles",
    route: "/threeDTitles",
    component: <Navigate to="/titles?segment=models" replace />,
  },
  {
    name: "embryologyThreeDTitles",
    key: "embryologyThreeDTitles",
    route: "/embryologyThreeDTitles",
    component: <Navigate to="/embryologyTitles?segment=models" replace />,
  },
  {
    type: "collapse",
    name: "Anatomy",
    key: "anatomyTitles",
    icon: <Icon fontSize="small">accessibility_new</Icon>,
    route: "/anatomyTitles",
    component: <Titles type="anatomy" />,
  },
  {
    type: "collapse",
    name: "Anatomy explorer",
    key: "anatomy-explorer-settings",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/anatomy-explorer-settings",
    component: <AnatomyExplorerSettingsPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Histology",
    key: "titles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/titles",
    component: <Titles type="his" />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" />,
  },
  {
    type: "collapse",
    name: "Radiology",
    key: "radiologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/radiologyTitles",
    component: <Titles type="rad" />,
  },
  {
    type: "collapse",
    name: "Quiz",
    key: "quiz",
    icon: <Icon fontSize="small">quiz</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Course Catalog",
        key: "quiz-titles",
        route: "/quiz/titles",
        component: <QuizSystem stage={0} />,
      },
      {
        type: "collapse",
        name: "Question Bank",
        key: "quiz-questions",
        route: "/quiz/questions",
        component: <QuizSystem stage={1} />,
      },
      {
        type: "collapse",
        name: "Create Quiz",
        key: "quiz-create",
        route: "/quiz/create",
        component: <QuizSystem stage={2} />,
      },
      {
        type: "collapse",
        name: "Heat map",
        key: "quiz-heatmap",
        route: "/quiz/heatmap",
        component: <HeatMap />,
      },
      {
        type: "collapse",
        name: "Results",
        key: "quiz-results",
        route: "/quiz/results",
        component: <QuizResults />,
      },
    ],
  },
  {
    type: "collapse",
    name: "General Quiz",
    key: "general-quiz",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/general-quiz/titles",
    component: <QuizTitles />,
  },
  {
    type: "collapse",
    name: "Presentations",
    key: "presentationTitles",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/presentationTitles",
    component: <PresentationTitles type="presentation" />,
  },
  {
    type: "collapse",
    name: "Public images",
    key: "public-images",
    icon: <Icon fontSize="small">collections</Icon>,
    route: "/public-images",
    component: <PublicImagesPage />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Push Notifications",
    key: "push",
    icon: <Icon fontSize="small">campaign</Icon>,
    route: "/push",
    component: <PushNotifications />,
  },
  {
    name: "presentationMakerPage",
    key: "presentationMakerPage",
    route: "/presentationMakerPage/:id/:lang",
    component: <PresentationMakerPage />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showQuestions",
    key: "showQuestions",
    route: "/showQuestions/:id/:lang",
    component: <ShowQuestions />,
  },
  {
    name: "studyPlanUsageDetail",
    key: "studyPlanUsageDetail",
    route: "/copilot-usage/study/:id",
    component: <StudyPlanUsageDetail />,
  },
  {
    name: "copilotUsageDetail",
    key: "copilotUsageDetail",
    route: "/copilot-usage/:id",
    component: <CopilotUsageDetail />,
  },
  /*
    Microlab Copilot — hidden routes (no `type: "collapse"`):
    processing screen (status polling) + study-pack viewer. Both are
    reached via `navigate(...)` from the hub, never from the sidebar.
  */
  {
    name: "microlabCopilotProcessing",
    key: "microlabCopilotProcessing",
    route: "/microlab-copilot/processing/:materialId",
    component: <MicrolabCopilotProcessing />,
  },
  {
    name: "microlabCopilotStudyPack",
    key: "microlabCopilotStudyPack",
    route: "/microlab-copilot/study/:materialId",
    component: <MicrolabCopilotStudyPack />,
  },
];

export default adminRoutes;
